module.exports = __webpack_public_path__ + "static/fonts/DB Heavent Li v3.2.93cbf0a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DB Heavent/DB Heavent Li v3.2.ttf
// module id = opQ+
// module chunks = 1